var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPilotIcon = function SvgPilotIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 59,
    viewBox: "0 0 64 59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "2mjcz6llxa",
    d: "M.157.109h42.996v12.59H.157z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7mwwsb2nmc",
    d: "M.135.188h28.809V14.6H.135z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.18 33.533a4.692 4.692 0 0 0-2.205-.631c-.92-.027-1.768.223-2.495.57-.595-1.98-1.778-2.985-3.421-3.541l12.11-.004c-1.956.416-3.445 1.262-3.99 3.606zM52.335 36.1l-.082-.69-1.59.187c.002-.075.005-.15.005-.225 0-3.932-2.361-6.937-7.305-6.143l-21.429.007c-.573-.047-1.17-.09-1.789-.136-4.697-.347-7.124 2.33-7.124 6.272 0 .08.003.16.005.24l-1.574-.146-.065.692 1.678.156c.327 3.679 2.624 7.426 8.409 6.196 6.713-1.428 7.053-3.087 8.3-7.14.042-.134.145-1.141.134-1.274.595-.297 1.29-.516 2.032-.494.636.018 1.249.218 1.834.594-.006.1.108 1.104.142 1.203 1.497 4.315 1.586 5.683 8.3 7.11 5.79 1.232 8.087-2.525 8.41-6.208l1.709-.2z",
    fill: "#164076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.113 25.809c0-1.515-1.432-2.645-2.895-2.252C4.381 24.855 0 25.902 0 33.785c0 8.986 4.38 10.393 9.218 11.692 1.463.393 2.895-.737 2.895-2.253V25.81zM51.609 25.809c0-1.515 1.432-2.645 2.895-2.252 4.837 1.298 9.218 2.345 9.218 10.228 0 8.986-4.38 10.393-9.218 11.692-1.463.393-2.895-.737-2.895-2.253V25.81z",
    fill: "#164076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.548 37.744a28.393 28.393 0 0 1-1.162-8.07c0-9.288 4.427-17.453 11.116-22.144 3.79-2.658 8.305-4.2 13.153-4.2 4.903 0 9.467 1.578 13.284 4.293 6.615 4.705 10.985 12.824 10.985 22.05 0 2.816-.408 5.528-1.162 8.071h2.672a31.455 31.455 0 0 0 1.045-8.07c0-10.88-5.497-20.367-13.642-25.365C40.944 1.92 36.447.556 31.655.556c-4.63 0-8.985 1.273-12.786 3.515C10.507 9 4.831 18.618 4.831 29.673c0 2.8.365 5.508 1.045 8.071h2.672z",
    fill: "#164076"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 .091)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jg0t2mltlb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2mjcz6llxa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.118 12.665a1.496 1.496 0 0 0 1.401-.44C8.973 7.644 15.01 4.83 21.655 4.83c6.646 0 12.681 2.813 17.135 7.393.378.39.899.552 1.402.441l1.653-.364c1.319-.29 1.763-2.145.76-3.148C37.284 3.837 29.091.109 21.654.109 14.217.109 6.024 3.837.705 9.153c-1.003 1.003-.56 2.858.76 3.148l1.653.364z",
    fill: "#F67347",
    mask: "url(#jg0t2mltlb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.6 43.691)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bquphegqxd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#7mwwsb2nmc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.052.35a35.71 35.71 0 0 1-16.345 9.786c-.285-.32-.784-.563-1.428-.709a2.344 2.344 0 0 0-1.944-.555L2.087 9.94A2.353 2.353 0 0 0 .169 12.65a2.353 2.353 0 0 0 2.708 1.917l6.249-1.068a2.344 2.344 0 0 0 1.648-1.166c.566-.355.962-.756 1.122-1.158a36.74 36.74 0 0 0 16.9-10.081c.466-.49-.276-1.235-.744-.743",
    fill: "#164076",
    mask: "url(#bquphegqxd)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPilotIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pilot-icon.8227a44d.svg";
export { ForwardRef as ReactComponent };